import { memo, useEffect, useMemo } from "react";
import { useTheme } from "@mui/material";
import { Marker, useMap } from "@vis.gl/react-google-maps";

interface MiCircleProps {
  center: google.maps.LatLngLiteral;
  radius: number;
  text?: string;
  options?: google.maps.CircleOptions;
}

const milesToMeters = (miles: number) => miles * 1609.34;

export const MiCircleMarker = memo(
  ({ center, radius, text, options }: MiCircleProps) => {
    const map = useMap();
    const theme = useTheme();

    const circle = useMemo(
      () =>
        new google.maps.Circle({
          fillColor: theme.palette.primary.light,
          fillOpacity: 0.6,
          strokeColor: theme.palette.primary.dark,
          strokeWeight: 2,
          clickable: false,
          ...options,
        }),
      [options]
    );

    useEffect(() => {
      circle.setMap(map);
      circle.setCenter(center);
      circle.setRadius(milesToMeters(radius));

      return () => circle.setMap(null);
    }, [map, circle, center, radius]);

    return text ? (
      <Marker
        position={center}
        icon={{
          path: google.maps.SymbolPath.CIRCLE,
          scale: 0,
        }}
        label={{
          text,
          color: theme.palette.primary.dark,
          fontSize: theme.fontSize.small,
          fontWeight: "600",
        }}
      />
    ) : null;
  }
);
